var _rect, _rect2, _rect3, _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Image(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 109,
    viewBox: "0 0 252 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 252,
    height: 109,
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Desktop"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12592,
    height: 6016,
    transform: "translate(-1100 -4810)",
    fill: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("g", {
    id: 404,
    clipPath: "url(#clip0_0_1)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-654 -190)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 21",
    d: "M-63 90.2104H315",
    stroke: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 3,
    width: 223,
    height: 106
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "404_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M167.066 71.4785L169.466 62.5217L225.734 10.5881L232.232 12.3292L228.514 26.2034L224.124 25.027L181.609 64.2696L181.421 64.9721L234.635 79.2307L232.047 88.89L167.066 71.4785ZM204.45 101.26L210.121 80.0973L211.238 75.9263L228.544 11.341L238.906 14.1174L214.812 104.036L204.45 101.26Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M125.571 108.483C118.723 108.483 112.889 106.619 108.071 102.892C103.253 99.1346 99.5712 93.6952 97.0257 86.574C94.4803 79.4224 93.2076 70.7861 93.2076 60.6649C93.2076 50.6043 94.4803 42.0133 97.0257 34.8921C99.6015 27.7406 103.298 22.2861 108.117 18.5285C112.965 14.7406 118.783 12.8467 125.571 12.8467C132.359 12.8467 138.162 14.7406 142.98 18.5285C147.829 22.2861 151.526 27.7406 154.071 34.8921C156.647 42.0133 157.935 50.6043 157.935 60.6649C157.935 70.7861 156.662 79.4224 154.117 86.574C151.571 93.6952 147.889 99.1346 143.071 102.892C138.253 106.619 132.42 108.483 125.571 108.483ZM125.571 98.483C132.359 98.483 137.632 95.2103 141.389 88.6649C145.147 82.1194 147.026 72.7861 147.026 60.6649C147.026 52.6043 146.162 45.7406 144.435 40.074C142.738 34.4073 140.283 30.0891 137.071 27.1194C133.889 24.1497 130.056 22.6649 125.571 22.6649C118.844 22.6649 113.586 25.983 109.798 32.6194C106.011 39.2255 104.117 48.574 104.117 60.6649C104.117 68.7255 104.965 75.574 106.662 81.2103C108.359 86.8467 110.798 91.1346 113.98 94.074C117.192 97.0133 121.056 98.483 125.571 98.483Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.1526 88.8906L16.7527 79.9339L39.5151 6.82406L46.0132 5.08291L49.7308 18.9571L45.3402 20.1336L28.1429 75.376L28.3312 76.0785L81.5449 61.8199L84.1331 71.4792L19.1526 88.8906ZM66.4188 95.99L60.7483 74.8275L59.6307 70.6564L42.3251 6.07113L52.6869 3.29471L76.7806 93.2136L66.4188 95.99Z",
    fill: "#9E9E9E"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 41",
    x: 0.071167,
    y: 0.209961,
    width: 278,
    height: 90,
    fill: "#D9D9D9"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white",
    transform: "translate(-654 -190)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Image);
export default __webpack_public_path__ + "static/media/404Image.e2c8fc129243b73965fe2b25972987d0.svg";
export { ForwardRef as ReactComponent };